module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-x-f7d79208.svg";